import React, { Component } from "react";
import styled from "styled-components";

import {ColorToStandardNames} from "./ColorToNumberDict";

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {isHovered:false, 
				tag:"",
				x:0,
				y:0};
	
	this.mouseHover = this.mouseHover.bind(this);
	this.mouseLeave = this.mouseLeave.bind(this);
	this.mouseLoc=this.mouseLoc.bind(this);
  }

  handleClick = e => {
    this.props.passColorToParent(e.target.attributes.color.value);
  };
  
  mouseHover(color){
	  this.setState({isHovered:true, tag:color})
  };
  mouseLeave(){
	  this.setState({isHovered:false, tag:""})
  };
   
 mouseLoc(e) {
    this.setState({ x: e.clientX, y: e.clientY });
  }

  render() {
    return (
	  <>
	  {/*<div>
	   Mouse coordinates: {this.state.x} {this.state.y}
	  </div>
	  */}
	  {/* tag  */}
	  <p style={{
		  position:'absolute',
		  fontSize:"14px",
		  top:this.state.y, 
		  left:this.state.x -15}}>
			{ColorToStandardNames[this.state.tag]}
	  </p>
	  
	  {/* color palette */}
	  <Container onMouseMove={this.mouseLoc}>
	   {[
          "#fff700",
		  "darkorange",
		  "crimson",
		  "violet",
		  "dodgerblue",
          "limegreen",
          "black",
          "white"
        ].map(color => (
          <Color
            color={color}
            selected={color === this.props.currentColor}
            onClick={this.handleClick}
			onMouseEnter={() => this.mouseHover(color)}
			onMouseLeave={this.mouseLeave}
          />
        ))}
	    
	   {/* color indicator */}
        <CurrentColor color={this.props.currentColor} />
      </Container>
	 
	  </>
    );
  }
}

export default ColorPicker;


const Container = styled.div`
  align-self: center;
  height: 60px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  transition: all 300ms;
  border-radius: 4px;
  cursor: pointer;
`;
const Color = styled.button`
  background: ${props => props.color};
  width: 3em;
  height: 3em;
  margin: 0 0.5em;
  border-radius: 50%;
  border: 1px solid black;
  outline: none;
  box-shadow: ${props =>
    props.selected ? "0 5px 10px rgba(0, 0, 0, 0.8)" : ""};
  transition: all 300ms;
  &:hover {
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.8);
  }
`;
const CurrentColor = styled(Color)`
  width: 1.5em;
  height: 1.5em;
  margin-left: 2em;
`;
